// extracted by mini-css-extract-plugin
module.exports = {"body":"Layout_body__wWRgG","bg":"Layout_bg__zBpTE","rotateClockwise":"Layout_rotateClockwise__oe1uC","red":"Layout_red__4j5y8","purple":"Layout_purple__Ohc1G"};